/**
 * @generated SignedSource<<9b0c3ebe97a1f9d0164ab99f1f2b3293>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetIssueOverviewIssueItemTitles_issue$data = {
  readonly task: {
    readonly title: string;
  };
  readonly title: string | null;
  readonly " $fragmentType": "WidgetIssueOverviewIssueItemTitles_issue";
};
export type WidgetIssueOverviewIssueItemTitles_issue$key = {
  readonly " $data"?: WidgetIssueOverviewIssueItemTitles_issue$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIssueOverviewIssueItemTitles_issue">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetIssueOverviewIssueItemTitles_issue",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "task",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    (v0/*: any*/)
  ],
  "type": "Issue",
  "abstractKey": null
};
})();

(node as any).hash = "77e0d299e91c0dccf134db97f853256c";

export default node;
